<template>
    <el-dialog :title="titleDialog"
               :visible="showDialog"
               append-to-body
               top="7vh"
               @close="close">
            <div class="form-body">
                <div class="row">
                    <div v-if="dispatchdetail.document_type_id == '09'"
                         class="col-md-12">
                        <table class="table">
                            <tr>
                                <th width="30%">Razón de traslado</th>
                                <th width="">: {{ dispatchdetail.transfer_reason_type.description }}</th>
                            </tr>
                            <tr>
                                <th width="30%">Descripción de motivo de traslado</th>
                                <th width="">: {{ dispatchdetail.transfer_reason_description }}</th>
                            </tr>
                            <tr>
                                <th width="30%">Punto de llegada:</th>
                                <th width="">: {{ dispatchdetail.delivery.address }} - {{ dispatchdetail.delivery.location_id }}</th>
                            </tr>
                        </table>
                    </div>
                    <div v-if="dispatchdetail.document_type_id == '31'"
                         class="col-md-12">
                        <table class="table">
                            <tr>
                                <th class="font-bold">Punto de partida</th>
                            </tr>
                            <tr style="border-bottom: 1px #f0f0f0 solid">
                                <th>{{ dispatchdetail.sender_address_data.location_id }} - {{ dispatchdetail.sender_address_data.address }}</th>
                            </tr>
                            <tr>
                                <th class="font-bold">Punto de llegada</th>
                            </tr>
                            <tr>
                                <th>{{ dispatchdetail.receiver_address_data.location_id }} - {{ dispatchdetail.receiver_address_data.address }}</th>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right pt-2">
                <el-button @click.prevent="close()">Cerrar</el-button>
            </div>
    </el-dialog>
</template>

<script>

export default {
    props: ['showDialog', 'dispatchdetail'],
    data() {
        return {
            showImportDialog: false,
            resource: 'dispatch',
            recordId: null,
            titleDialog: 'Detalles de Guía',

        }
    },
    created() {
        console.log(this.dispatch) 
    },
    methods: {
        close() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
